import React, { useEffect, useState } from 'react';
export const useTab = (selectedTabId, children) => {
    const tabIds = React.Children.toArray(children).map((child) => child.props.id);
    const defaultSelectedTabId = selectedTabId || tabIds[0];
    const [selectedTab, setSelectedTab] = useState(defaultSelectedTabId);
    useEffect(() => {
        if (selectedTab && !tabIds.includes(selectedTab)) {
            setSelectedTab(defaultSelectedTabId);
        }
    }, [tabIds, selectedTab, defaultSelectedTabId]);
    const selectTab = (currentSelectedTab, disable = false) => {
        if (!disable) {
            setSelectedTab(currentSelectedTab);
        }
    };
    return {
        selectedTab,
        selectTab,
    };
};
export const scrollTabIntoView = (tabId) => {
    const tab = document.getElementById(tabId);
    if (tab) {
        tab.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
        });
    }
};
//# sourceMappingURL=tab-util.js.map